module.exports = __webpack_public_path__ + "img/11.55eaceb9.png";